module.exports = __webpack_public_path__ + "img/lc.5ad21ab7.png";